export function isOutcomeOnboardingEnabled() {
  // The outcome chooser replaces the completed intent-picker experiment.
  // Keep one explicit rollback switch for staged deployments.
  return process.env.REACT_APP_ENABLE_OUTCOME_ONBOARDING !== 'false';
}
